import React, { Component } from 'react';
//import { NavLink } from "react-router-dom"
import { authentication } from '../services/Authentication';

import { config } from '../Constants';
import helpers from '../Function';

import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import Checkbox from '@material-ui/core/Checkbox';
import $ from "jquery";

import { Button, Upload } from "antd";
import { ExcelRenderer } from "react-excel-renderer";

import CircularProgress from '@material-ui/core/CircularProgress';
import ReactExport from "react-export-excel";
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import {ValidatePngMatchSize} from '../utils/validateImage'

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class BeyondService extends Component {
    fileObj = [];
    fileArray = [];

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission } = authentication.currentUserValue;

        this.state = {
            userid: user_id,
            jwt: jwt,
            user_permission: user_permission,
            pages: [],
            rows: [],
            addIsOpen: false,
            srcIsOpen: false,
            deleteIsOpen: false,
            updateIsOpen: false,
            importIsOpen: false,
            content_id: '',
            methodOpen: '',
            imgCollection: '',
            add_id: '',
            add_name: '',
            add_name_en: "",
            add_phone: '',
            add_link: '',
            add_mail: '',
            add_description: '',
            add_active_status: '',
            add_img: '',
            active: true,
            create_by: name,
            create_by_id: user_id,
            usertype: user_type,
            src_active: false,
            src_nonactive: false,
            file: null,
            file_gallery: [null],
            page: 0,
            rowsPerPage: 10,
            miss_su: helpers.getUserType(user_type, "su"),
            spinner: false,
            add_seq: '',
            IsVerify: false
        };

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.closeAdd = this.closeAdd.bind(this);
        this.openAdd = this.openAdd.bind(this);
        this.submitAdd = this.submitAdd.bind(this);

        this.openEdit = this.openEdit.bind(this);
        this.openView = this.openView.bind(this);

        this.change = this.change.bind(this);
        this.dataTable = this.dataTable.bind(this);
        this.submitEdit = this.submitEdit.bind(this);

        this.closeSrc = this.closeSrc.bind(this);
        this.openSrc = this.openSrc.bind(this);
        this.submitSrc = this.submitSrc.bind(this);

        this.handleCheck = this.handleCheck.bind(this)

        this.openDelete = this.openDelete.bind(this);
        this.closeDelete = this.closeDelete.bind(this);
        this.submitDelete = this.submitDelete.bind(this);

        this.onChange = this.onChange.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.closeModelUpdate = this.closeModelUpdate.bind(this);


        this.handleActiveSrcCheck = this.handleActiveSrcCheck.bind(this)
        this.handleNonActiveSrcCheck = this.handleNonActiveSrcCheck.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);

        this.uploadMultipleFiles = this.uploadMultipleFiles.bind(this)


        this.openImport = this.openImport.bind(this);
        this.closeImport = this.closeImport.bind(this);
        this.submitImport = this.submitImport.bind(this);

        this.submitVerify = this.submitVerify.bind(this)

        this.dataTable();

    }

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    dataTable() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/getBeyondServiceDetail', requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var data = dataMain.data
                    this.setState({
                        pages: [].concat(data)
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
        }
    }

    dataTableSrc() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            let body = `?active=${this.state.src_active}&nonactive=${this.state.src_nonactive}&name=${this.state.add_name}&name_en=${this.state.add_name_en}&phone=${this.state.add_phone}`
    
            fetch(config.url.API_URL + '/getBeyondServiceDetailSrc' + body, requestOptions)
                .then(res => res.json())
                .then(data => {
                    if (Array.isArray(data.data) && data.data.length) {
                        this.setState({
                            pages: [].concat(data.data)
                        });
    
                    } else {
                        this.setState({
                            pages: []
                        });
                    }
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
        }
    }

    submitSrc(e) {
        this.dataTableSrc()
        this.setState({ srcIsOpen: false });
    }

    openAdd() {
        this.fileObj = [];
        this.fileArray = [];
        this.setState({
            addIsOpen: true,
            methodOpen: 'add',
            add_id: '',
            add_name: '',
            add_name_en: '',
            add_phone: '',
            add_link: '',
            add_mail: '',
            add_seq: '',
            add_description: '',
            add_active_status: '',
            add_img: '',
            active: true,
            file: null
        });
    }

    openEdit(e) {
        try {
            this.fileObj = [];
            this.fileArray = [];
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/getBeyondServiceDetail/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var data = dataMain.data;
                    this.setState({
                        add_id: data.id,
                        add_name: data.name,
                        add_name_en: data.name_en,
                        add_phone: data.phone,
                        add_description: data.description,
                        add_mail: data.email,
                        add_link: data.link,
                        add_seq: (data.seq == undefined || data.seq == 'undefined') ? "" : data.seq,
                        add_active_status: data.active_status,
                        active: data.active
                    });
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'edit'
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
            
        }
    }

    openView(e) {
        try {
            this.fileArray = []
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/getBeyondServiceDetail/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var data = dataMain.data;
                    this.setState({
                        add_id: data.id,
                        add_name: data.name,
                        add_name_en: data.name_en,
                        add_phone: data.phone,
                        add_description: data.description,
                        add_mail: data.email,
                        add_link: data.link,
                        add_seq: (data.seq == undefined || data.seq == 'undefined') ? "" : data.seq,
                        add_active_status: data.active_status,
                        add_img: data.img,
                        add_img_gallerys: data.gallerys
                    });
                    if (this.state.add_img_gallerys.length > 0) {
                        for (let i = 0; i < this.state.add_img_gallerys.length; i++) {
                            this.fileArray.push(this.state.add_img_gallerys[i]['image'])
                        }
                    }
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'view'
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    closeDelete() {
        this.setState({ deleteIsOpen: false });
        this.dataTable();
    }

    closeAdd() {
        this.setState({
            add_id: '',
            add_name: '',
            add_name_en: '',
            add_name_en: '',
        });
        this.setState({ addIsOpen: false });
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
    }

    closeModelUpdate() {
        this.setState({ updateIsOpen: false });
        this.dataTable();
    }

    openSrc(e) {
        this.setState({
            srcIsOpen: true,
            src_active: false,
            src_nonactive: false,
            add_name: '',
            add_name_en: '',
            add_phone: '',
            page: 0
        });
    }

    submitAdd() {
        // this.setState({ addIsOpen: false, spinner: true });
        try {
            
            if (!this.state.add_name) {
                alert('ไม่พบข้อมูลหัวเรื่อง');
                return;
            }

            if (!this.state.add_name_en) {
                alert('ไม่พบข้อมูลหัวเรื่องอังกฤษ');
                return;
            }

            if (!this.state.add_phone) {
                alert('ไม่พบข้อมูลเบอร์โทรศัพท์');
                return;
            }

            if (!this.state.active) {
                this.setState({
                    active: true
                });
            }

            if (!this.state.file) {
                alert('ไม่พบข้อมูลไอคอน');
                return;
            }

            if (!this.state.file_gallery) {
                alert('ไม่พบข้อมูลแกลลอรี่');
                return;
            }

            const formData = new FormData();
            formData.append('name', this.state.add_name);
            formData.append('name_en', this.state.add_name_en);
            formData.append('phone', this.state.add_phone);
            formData.append('description', this.state.add_description);
            formData.append('email', (this.state.add_mail == undefined || this.state.add_mail == null || this.state.add_mail == '') ? "" : this.state.add_mail);
            formData.append('seq', (this.state.add_seq == undefined || this.state.add_seq == null || this.state.add_seq == '') ? "" : this.state.add_seq);
            formData.append('link', this.state.add_link);
            formData.append('active', this.state.active);
            formData.append('createby', this.state.create_by);
            formData.append('createby_id', this.state.create_by_id);
            formData.append('myImage', this.state.file);
            for (const key of Object.keys(this.state.imgCollection)) {
                formData.append('myGallery', this.state.imgCollection[key])
            }


            const requestOptions = {
                method: 'POST',
                headers: {
                    'Authorization': this.state.jwt,
                },
                body: formData
            };

            fetch(config.url.API_URL + '/createBeyondServiceDetail', requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true,
                        spinner: false,
                        file: null,
                        file_gallery: [null]
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });

            this.setState({ addIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
            
        }
    }

    submitDelete(e) {
        try {
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    updateby: this.state.create_by,
                    updateby_id: this.state.create_by_id
                }),
            };
    
            fetch(config.url.API_URL + '/deleteBeyondServiceDetail/' + this.state.content_id, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true,
                        file: null
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            this.setState({ deleteIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openDelete(e) {
        this.setState({
            deleteIsOpen: true,
            content_id: e.currentTarget.attributes["data-id"].value
        });
    }

    submitEdit(e) {
        try {
            const formData = new FormData();
            formData.append('name', this.state.add_name);
            formData.append('name_en', this.state.add_name_en);
            formData.append('phone', this.state.add_phone);
            formData.append('description', this.state.add_description);
            formData.append('email', this.state.add_mail);
            formData.append('seq', (this.state.add_seq == undefined || this.state.add_seq == "undefined") ? "": this.state.add_seq);
            formData.append('link', this.state.add_link);
            formData.append('active', this.state.active);
            formData.append('updateby', this.state.create_by);
            formData.append('updateby_id', this.state.create_by_id);
            formData.append('myImage', this.state.file);
            for (const key of Object.keys(this.state.imgCollection)) {
                formData.append('myGallery', this.state.imgCollection[key])
            }
    
    
            const requestOptions = {
                method: 'PUT',
                headers: {
                    'Authorization': this.state.jwt,
                },
                body: formData
            };
            fetch(config.url.API_URL + '/updateBeyondServiceDetail/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true,
                        addIsOpen: false,
                        file: null
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleCheck() {
        this.setState({ active: !this.state.active });
    }

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    onChange(e) {
        const fileName = e.target.files[0]

        const validateOption = {
            width: 120,
            height: 120,
        }
        
        ValidatePngMatchSize(fileName, validateOption)
            .then(() => this.setState({ file: fileName }))
            .catch(err => {
                document.getElementsByName('myImage')[0].value = null
                alert(err)
            })

    }

    handleActiveSrcCheck() {
        this.setState({
            src_active: !this.state.src_active
        });
    }

    handleNonActiveSrcCheck() {
        this.setState({
            src_nonactive: !this.state.src_nonactive
        });
    }

    handleChange(event) {
        this.setState({ add_description: event.target.value });
    }

    uploadMultipleFiles(e) {

        // const validateOption = {
        //     width: 120,
        //     height: 120,
        // }
        
        // ValidatePngMatchSize(fileName, validateOption)
        //     .then(() => this.setState({ file: fileName }))
        //     .catch(err => {
        //         document.getElementsByName('myImage')[0].value = null
        //         alert(err)
        //     })

        this.fileObj.push(e.target.files)
        for (let i = 0; i < this.fileObj[0].length; i++) {
            this.fileArray.push(URL.createObjectURL(this.fileObj[0][i]))
        }
        
        this.setState({
            file_gallery: this.fileArray,
            imgCollection: e.target.files
        })
    }

    openImport() {
        this.setState({
            importIsOpen: true,
            rows: [],
            errorMessage: null,
            IsVerify: false
        });
    }

    closeImport() {
        this.setState({
            importIsOpen: false,
        });
    }

    submitImport() {
        try {
            if (!this.state.rows) {
                alert("ไม่มีข้อมูลการ import")
                return
            }
    
            if (!this.state.IsVerify) {
                alert("ยังไม่ได้ทำการตรวจสอบข้อมูล")
                return
            } else {
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': this.state.jwt,
                    },
                    body: JSON.stringify({
                        import_data: this.state.rows,
                        createby: this.state.create_by,
                        createby_id: this.state.create_by_id
    
                    })
                };
    
                fetch(config.url.API_URL + '/import_beyondservice', requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        this.setState({
                            importIsOpen: false,
                            updateIsOpen: true
                        });
                    }).catch(error => {
                        console.log(error)
                        //window.location.reload(); // Reload the page
                    });
    
            }
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    async submitVerify() {
        console.log(this.state.rows)
        if (!this.state.rows || this.state.rows.length == 0) {
            alert("ไม่มีข้อมูลการ import")
            return
        }

        alert("ตรวจสอบเรียบร้อย")
        const rows = this.state.rows
        let errorRow = 0
        await Promise.all(rows.map(items =>{
            items.comment = ""
            if(items.service == null || items.service == undefined || items.service == ""){
                items.comment += "ไม่พบ ชื่อเซอร์วิส"
                if(items.phone == null || items.phone == undefined || items.phone == ""){
                    items.comment += "\nไม่พบ เบอร์โทรศัพท์"
                }

                errorRow ++
            }else if(items.phone == null || items.phone == undefined || items.phone == ""){
                items.comment += "\nไม่พบ เบอร์โทรศัพท์"
                errorRow ++
            }
            else{
                items.comment = "Ready"
            }

            return items
        }))


        console.log(errorRow)
        if(errorRow == 0){
            console.log("IF")
            document.getElementById("btnImport").disabled = false;
            this.setState({
                rows: this.state.rows,
                errorMessage: null,
                IsVerify: true
            });
        }else{
            console.log("ELSE")
            document.getElementById("btnImport").disabled = true;
            this.setState({
                rows: this.state.rows,
                errorMessage: null,
                IsVerify: false
            });
        }
        // this.setState({
        //     rows: this.state.rows,
        //     errorMessage: null,
        //     IsVerify: true
        // });

    }

    fileHandler = fileList => {
        console.log("fileList", fileList);
        let fileObj = fileList;
        if (!fileObj) {
            this.setState({
                errorMessage: "No file uploaded!"
            });
            return false;
        }
        console.log("fileObj.type:", fileObj.type);
        if (
            !(
                fileObj.type === "application/vnd.ms-excel" ||
                fileObj.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            )
        ) {
            this.setState({
                errorMessage: "Unknown file format. Only Excel files are uploaded!"
            });
            return false;
        }
        //just pass the fileObj as parameter
        ExcelRenderer(fileObj, (err, resp) => {
            if (err) {
                console.log(err);
            } else {
                let newRows = [];
                resp.rows.slice(1).map((row, index) => {
                    if (row && row !== "undefined") {
                        newRows.push({
                            key: index,
                            service: row[0],
                            phone: row[1],
                            detail: row[2],
                            link: row[3],
                            email: row[4],
                        });
                    }
                }, {});
                if (newRows.length === 0) {
                    this.setState({
                        errorMessage: "No data found in file!"
                    });
                    return false;
                } else {
                    this.setState({
                        rows: newRows,
                        errorMessage: null
                    });
                }
            }
        });
        return false;
    };

    render() {
        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 8,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);

        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Beyond Service List</h1>
                            </div>{/* /.col */}
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">beyondService</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}
                {/* Main content */}
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="btn-advance text-center" onClick={this.openSrc}>ค้นหาขั้นสูง</div>
                                    {(this.state.user_permission[115].permission == 1 &&
                                        <div className="btn-add text-center" onClick={this.openAdd}>เพิ่มข้อมูล</div>
                                    )}
                                    <ExcelFile filename="beyondservice" element={(
                                        this.state.user_permission[237].permission == 1 && <div className="btn-add text-center">Export Data</div>
                                    )}>
                                        <ExcelSheet data={this.state.pages} name="beyondservice">
                                            <ExcelColumn label="Service" value={(col) => col.name} />
                                            <ExcelColumn label="เบอร์โทร" value={(col) => col.phone} />
                                            <ExcelColumn label="รายละเอียด" value={(col) => col.description} />
                                            <ExcelColumn label="link" value={(col) => col.link} />
                                            <ExcelColumn label="email" value={(col) => col.email} />
                                            <ExcelColumn label="icon" value={(col) => col.img} />
                                            <ExcelColumn label="gallerys" value={(col) => col.gallerys.toString()} />
                                            <ExcelColumn label="อัพเดทล่าสุด" value={(col) => col.updateby} />
                                            <ExcelColumn label="อัพเดทล่าสุด(วันที่)" value={(col) => col.updated} />
                                        </ExcelSheet>
                                    </ExcelFile>
                                    {(this.state.user_permission[236].permission == 1 &&
                                        <div className="btn-add text-center" onClick={this.openImport}>Import</div>
                                    )}
                                    {(this.state.user_permission[238].permission == 1 &&
                                        <div className="btn-add text-center" ><a href={'https://admin.nvdsmarthome.com/downloadFile/Import_beyondservice.xlsx'} style={{ color: 'black' }}>Download Template</a></div>
                                    )}
                                </div>
                                {/* .card-header */}
                                <div className="card-body">
                                    {
                                        this.state.spinner && <div style={{ textAlign: 'center' }}><CircularProgress /></div>
                                    }
                                    {
                                        !this.state.spinner && <TableContainer component={Paper}>
                                            <Table aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell style={{ width: '100px' }}>No</StyledTableCell>
                                                        <StyledTableCell style={{ width: '100px' }}>icon</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>Service</StyledTableCell>
                                                        <StyledTableCell style={{ width: '200px' }}>เบอร์โทร</StyledTableCell>
                                                        <StyledTableCell style={{ width: '200px' }}>สถานะการใช้งาน</StyledTableCell>
                                                        <StyledTableCell style={{ width: '200px' }}>วันทีสร้าง</StyledTableCell>
                                                        <StyledTableCell style={{ width: 'auto' }}>อัพเดทล่าสุด</StyledTableCell>
                                                        <StyledTableCell style={{ width: '100px' }}>รายละเอียด</StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                            this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                                return (
                                                                    <StyledTableRow key={`1${i}`}>
                                                                        <StyledTableCell style={{ textAlign: 'center' }}>{data.num}</StyledTableCell>
                                                                        <StyledTableCell style={{ textAlign: 'center' }}>{data.img && <img src={data.img} alt="pic" height="50" width="auto" style={{ verticalAlign: "text-top" }} />}</StyledTableCell>
                                                                        <StyledTableCell>{data.name}</StyledTableCell>
                                                                        <StyledTableCell>{data.phone}</StyledTableCell>
                                                                        <StyledTableCell>{data.active_status}</StyledTableCell>
                                                                        <StyledTableCell>{data.create}</StyledTableCell>
                                                                        <StyledTableCell>{data.updateby}<br />{data.updateby != undefined ? data.updated : ""}</StyledTableCell>
                                                                        <StyledTableCell>
                                                                            <button className="btn-action text-center" data-id={data.id} onClick={this.openView}><img src="dist/img/icon/ic_view.png" className="btn-icon" alt="" />View</button>

                                                                            {(this.state.user_permission[116].permission == 1 &&
                                                                                <button className="btn-action text-center" data-id={data.id} onClick={this.openEdit}><img src="dist/img/icon/ic_update.png" className="btn-icon" alt="" /> Update</button>
                                                                            )}
                                                                            {(this.state.user_permission[117].permission == 1 &&
                                                                                <button className="btn-action text-center" data-id={data.id} onClick={this.openDelete}><img src="dist/img/icon/ic_del.png" className="btn-icon" alt="" /> Delete</button>
                                                                            )}
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>)
                                                            })
                                                    }

                                                    {emptyRows > 0 && (
                                                        <StyledTableRow>
                                                            <StyledTableCell colSpan={6} />
                                                        </StyledTableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                            <TablePagination
                                                rowsPerPageOptions={[10, 25, 50]}
                                                component="div"
                                                count={this.state.pages.length}
                                                rowsPerPage={this.state.rowsPerPage}
                                                page={this.state.page}
                                                onChangePage={this.handleChangePage}
                                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                            />
                                        </TableContainer>
                                    }

                                </div>
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </section>
                {/* /.content */}
                <Modal show={this.state.srcIsOpen} onHide={this.closeSrc} size="lg">
                    <ModalHeader>
                        <ModalTitle>ค้นหาขั้นสูง</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-serach">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">Service-ไทย</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="add_name" name="add_name" defaultValue={this.state.add_name} onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">Service-อังกฤษ</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="add_name_en" name="add_name_en" defaultValue={this.state.add_name_en} onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">เบอร์โทรศัพท์</div>
                                <div className="col-sm-3 text-right">
                                    <input type="text" className="form-control" id="add_phone" name="add_phone" defaultValue={this.state.add_phone} onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3" >
                                <div className="col-sm-3 text-right">สถานะ</div>
                                <div className="col-sm-5">
                                    <Checkbox
                                        checked={this.state.src_active}
                                        onChange={this.handleActiveSrcCheck}
                                        color="primary"
                                    /> ใช้งาน
                                    <Checkbox
                                        checked={this.state.src_nonactive}
                                        onChange={this.handleNonActiveSrcCheck}
                                        color="primary"
                                    /> ไม่ได้ใช้งาน
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeSrc}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-success" onClick={this.submitSrc}>ค้นหาข้อมูล</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.addIsOpen} onHide={this.closeAdd} size="xl">
                    <ModalHeader>
                        <ModalTitle>{(this.state.methodOpen === 'add' && "เพิ่มข้อมูล") || (this.state.methodOpen === 'edit' && "แก้ไขข้อมูล") || (this.state.methodOpen === 'view' && "ตรวจสอบข้อมูล")}</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">Service-ไทย<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_name" name="add_name" defaultValue={this.state.add_name} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_name}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">Service-อังกฤษ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_name_en" name="add_name_en" defaultValue={this.state.add_name_en} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_name_en}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ไอคอน<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-9">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="file" name="myImage" onChange={this.onChange} accept="image/png, image/jpeg" />)
                                        : (this.state.add_img && <img src={this.state.add_img} alt="pic" height="120" width="auto" />)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-7 text-right"><span style={{ color: 'red', fontSize: '18px' }}>*หมายเหตุ : รองรับไฟล์ขนาดไม่เกิน 1 MB (120*120px) เฉพาะไฟล์ PNG เท่านั้น</span></div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">รายละเอียด</div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<textarea defaultValue={this.state.add_description} className="form-control" rows="1" onChange={this.handleChange} />)
                                        : (<textarea value={this.state.add_description} className="form-control" rows="1" disabled />)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">เบอร์โทรศัพท์<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-3">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_phone" name="add_phone" defaultValue={this.state.add_phone} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_phone}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">Link</div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<TextareaAutosize className="form-control" name="add_link" rowsMin={1} defaultValue={this.state.add_link} onChange={this.change} />)
                                        : (<TextareaAutosize className="form-control" name="add_link" rowsMin={1} defaultValue={this.state.add_link} onChange={this.change} disabled />)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">Email</div>
                                <div className="col-sm-3">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_mail" name="add_mail" defaultValue={this.state.add_mail} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_mail}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ลำดับ</div>
                                <div className="col-sm-3">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_seq" name="add_seq" defaultValue={this.state.add_seq} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_seq}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">Gallery<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-9">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="file" name="myImage" onChange={this.uploadMultipleFiles} multiple accept="image/png, image/jpeg" />)
                                        : ""}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right"></div>
                                <div className="col-sm-9">
                                    {(this.fileArray || []).map((url, i) => (
                                        <img key={i} src={url} alt="..." height="150" width="auto" />
                                    ))}
                                </div>
                            </div>
                            {/* <div className="row mb-3">
                                <div className="col-sm-7 text-right"><span style={{ color: 'red', fontSize: '18px' }}>*หมายเหตุ : รองรับไฟล์ขนาดไม่เกิน 1 MB (1125*2436px) เฉพาะไฟล์ JPG,PNG</span></div>
                            </div> */}
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">สถานะ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<p><Checkbox
                                            checked={this.state.active}
                                            onChange={this.handleCheck}
                                            color="primary"
                                        />ใช้งาน</p>)
                                        : (<div>
                                            <p>{this.state.add_active_status}</p>
                                        </div>)}
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        {(this.state.methodOpen === 'add' &&
                            (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                <button className="btn btn-success" onClick={this.submitAdd}>เพิ่มข้อมูล</button></div>))
                            || (this.state.methodOpen === 'edit' &&
                                (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                    <button className="btn btn-warning" data-id={this.state.add_id} onClick={this.submitEdit}>แก้ไขข้อมูล</button></div>))
                            || (this.state.methodOpen === 'view' &&
                                (<div><button className="btn btn-success" onClick={this.closeAdd}>ตกลง</button></div>))}
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.updateIsOpen} onHide={this.closeModelUpdate} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        บันทึกรายการสำเร็จ
                        </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeModelUpdate}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.deleteIsOpen} onHide={this.closeDelete} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        ยืนยันการลบรายการหรือไม่
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeDelete}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-warning" onClick={this.submitDelete}>ยืนยัน</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.importIsOpen} onHide={this.closeImport} size="xl">
                    <ModalHeader>
                        <div className="row">
                            <div className="col-sm-12">
                                <Upload name="file" beforeUpload={this.fileHandler} onRemove={() => this.setState({ rows: [] })} multiple={false} accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" >
                                    <Button className="btn btn-primary"> Import Excel File </Button>
                                </Upload>
                            </div>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-12">
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: 'auto' }}>service</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>เบอร์โทรศัพท์</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>รายละเอียด</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>Link</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>Email</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>หมายเหตุ</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.rows.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={`1${i}`}>
                                                                    <StyledTableCell>{data.service}</StyledTableCell>
                                                                    <StyledTableCell>{data.phone}</StyledTableCell>
                                                                    <StyledTableCell>{data.detail}</StyledTableCell>
                                                                    <StyledTableCell>{data.link}</StyledTableCell>
                                                                    <StyledTableCell>{data.email}</StyledTableCell>
                                                                    <StyledTableCell  style={data.comment == "Ready" ?{ color:"green"} :{ color: "red"}}>{data.comment == undefined ? "" : data.comment}</StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.rows.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <div className='row'>
                            <button className="btn btn-warning" onClick={this.submitVerify}>ตรวจสอบข้อมูล</button>
                        &nbsp;&nbsp;
                            <button className="btn btn-danger" onClick={this.closeImport}>ยกเลิก</button>
                        &nbsp;&nbsp;
                            <button id="btnImport" className="btn btn-success" data-id={this.state.add_id} onClick={this.submitImport}>ตกลง</button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}